<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <p>{{ data.content }}</p>
        <p class="text-danger mt-2"><strong>* Please input your signature below. This is required for confirmation.</strong>
        </p>
        <div class="signature-pad-container">
            <canvas #signatureCanvas class="signature-canvas"></canvas>
        </div>

        <div class="signature-controls mt-2">
            <button mat-button (click)="clearCanvas()">Clear</button>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="yes-button" *ngIf="!isLoading; else loadingTemplate" (click)="saveSignature()"
            [disabled]="!hasSigned" cdkFocusInitial>
            {{ data.confirmText }}
        </button>
        <ng-template #loadingTemplate>
            <button mat-button class="yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>